import { AUCUN } from '@/configuration/parametrage/modeReglementConf';

export default function genererModeReglement() {
  return {
    libelle: '',
    actionAchat: AUCUN,
    aEffet: true,
    centralisationCompteBanque: true,
    ribObligatoire: true,
    codeExterneComptabilite: '',
    codeExterneFactor: '',
  };
}
